// DOG1 Form Loading State Handler (Cluster O2-Mig.2)
// Setzt .dog1-form--loading auf Form-Submit → visuelles Disabled-Visual
// auf den O2-Inputs (CSS in dog1-form-controls.css.liquid) + Submit-Button
// aria-busy. Greift auf alle <form class="dog1-form">.

(function () {
  'use strict';

  var forms = document.querySelectorAll('.dog1-form');

  forms.forEach(function (form) {
    form.addEventListener('submit', function () {
      // HTML5-Native-Validation ist hier bereits durch — der Browser
      // hätte den Submit sonst gar nicht ausgelöst.
      form.classList.add('dog1-form--loading');

      var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) {
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.disabled = true;
      }
      // Browser submitted normal weiter; .dog1-form--loading verschwindet
      // mit dem Page-Reload nach dem Submit.
    });
  });
})();
